import React from "react";
import Aboutv6 from "../aboutv6";
import Booksv1 from "../booksv1";
import Booksv2 from "../booksv2";
import Contact from "../contact";
import Ctav5 from "../ctav5";
import Event from "../event";
import Footer from "../global/footer";
import Header from "../global/header";
import Herov6 from "../herov6";
import Testimonial from "../testimonial";
import Gallery from "../gallery";

const Version06 = ({ headerv2, footer }) => {
  const { menuv2 } = footer;

  return (
    <>
      <Header header={headerv2} />
      <Herov6 isBg="yes"/>
      <Aboutv6 isBg=""/>
      <Booksv1 isBg="yes"/>
      <Gallery isBg="" />
      <Ctav5 />
      <Booksv2 isBg=""/>
     
      <Testimonial isBg="yes"/>
      <Contact isBg=""/>
      <Footer isBg="yes" menu={menuv2} />
    </>
  );
};

export default Version06;
